// === GENERATED FILE ===
// DO NOT EDIT DIRECTLY, EDIT sh-button.lit.scss INSTEAD!
import { css } from 'lit-element';
export default css`:root,
[sh-scale=s] {
  /* 
   * @cssprop [--sh-button-button-height=2rem] - height of the button
   */
  --sh-button-button-height: 2rem;
  /* 
   * @cssprop [--sh-button-width-size-s=6rem] - width of the button s
   */
  --sh-button-width-size-s: 6rem;
  /* 
   * @cssprop [--sh-button-width-size-m=9.5rem] - width of the button m
   */
  --sh-button-width-size-m: 9.5rem;
  /* 
   * @cssprop [--sh-button-width-size-l=11.5rem] - width of the button l
   */
  --sh-button-width-size-l: 11.5rem;
  /* 
   * @cssprop [--sh-button-label-line-height=1.5rem] - line height of the label
   */
  --sh-button-label-line-height: 1.5rem;
  /* 
   * @cssprop [--sh-button-button-border-radius=1rem] - border radius of the button
   */
  --sh-button-button-border-radius: 1rem;
  /* 
   * @cssprop [--sh-button-button-padding=0.25rem 1rem] - padding of the button
   */
  --sh-button-button-padding: 0.25rem 1rem;
  /* 
   * @cssprop [--sh-button-icon-width=3rem] - width of the icon button
   */
  --sh-button-icon-width: 3rem;
  /* 
   * @cssprop [--sh-button-icon-height=3rem] - height of the icon button
   */
  --sh-button-icon-height: 3rem;
  /* 
   * @cssprop [--sh-button-icon-size=2rem] - size of the icon
   */
  --sh-button-icon-size: 2rem;
  /* 
   * @cssprop [--sh-button-icon-padding=0.5rem] - padding of the icon
   */
  --sh-button-icon-padding: 0.5rem;
  /* 
   * @cssprop [--sh-button-padding-right-left=2rem] - left right padding of the button
   */
  --sh-button-padding-right-left: 2rem;
  /* 
   * @cssprop [--sh-button-tooltip-height=1.5rem] - line height and height of the tooltip
   */
  --sh-button-tooltip-height: 1.5rem;
  /* 
   * @cssprop [--sh-button-tooltip-max-width=15rem] - max width of the tooltip
   */
  --sh-button-tooltip-max-width: 15rem;
  /* 
   * @cssprop [--sh-button-tooltip-top-margin=0rem] - margin-top for the tooltip
   */
  --sh-button-tooltip-top-margin: 0rem;
  /* 
   * @cssprop [--sh-button-tooltip-margin=0.25rem] - margin for the tooltip
   */
  --sh-button-tooltip-margin: 0.25rem;
  /* 
   * @cssprop [--sh-button-tooltip-margin-top=-1.5rem] - margin for tooltip top placement
   */
  --sh-button-tooltip-margin-top: -1.5rem;
  /* 
   * @cssprop [--sh-button-tooltip-hover-margin-top=-1.75rem] - margin for tooltip top placement on hover
   */
  --sh-button-tooltip-hover-margin-top: -1.75rem;
  /* 
   * @cssprop [--sh-button-tertiary-border-thickness=0.0625rem] - border thickness of a tertiary button
   */
  --sh-button-tertiary-border-thickness: 0.0625rem;
  /* 
   * @cssprop [--sh-button-flex-shrink-icon=unset] - flex-shrink of an icon button
   */
  --sh-button-flex-shrink-icon: unset;
}

:host {
  display: flex;
  height: var(--sh-button-button-height);
  padding: var(--sh-button-button-padding);
  position: relative;
  flex-direction: row;
  border-radius: var(--sh-button-button-border-radius);
  cursor: pointer;
  box-sizing: border-box;
  outline: 0;
  justify-content: center;
}

:host([icon]) {
  flex-shrink: var(--sh-button-flex-shrink-icon);
}

.label {
  text-align: center;
  align-self: center;
  line-height: var(--sh-button-label-line-height) !important;
  font: var(--title-1);
  overflow: hidden;
  white-space: nowrap;
  -o-text-overflow: ellipsis;
  text-overflow: ellipsis;
  font-weight: bold;
  -webkit-font-smoothing: antialiased !important;
  text-rendering: optimizeLegibility !important;
  -moz-osx-font-smoothing: grayscale !important;
  -moz-user-select: none;
  -webkit-user-select: none;
}

:host sh-icon {
  margin: auto;
}

/* size */
:host(:not([icon])[size=s]) .label,
:host([shape=pill-s]) .label {
  width: calc(var(--sh-button-width-size-s) - var(--sh-button-padding-right-left));
}

:host(:not([icon])[size=m]) .label,
:host([shape=pill-m]) .label {
  width: calc(var(--sh-button-width-size-m) - var(--sh-button-padding-right-left));
}

:host(:not([icon])[size=l]) .label,
:host([shape=pill-l]) .label {
  width: calc(var(--sh-button-width-size-l) - var(--sh-button-padding-right-left));
}

/* icon button */
:host([icon]:not([shape^=pill-])) {
  position: relative;
  width: var(--sh-button-icon-width);
  height: var(--sh-button-icon-height);
  padding: var(--sh-button-icon-padding);
  border-radius: 50%;
}

sh-icon {
  font-size: var(--sh-button-icon-size);
  line-height: var(--sh-button-icon-size);
  max-height: var(--sh-button-icon-size);
  min-height: var(--sh-button-icon-size);
  min-width: var(--sh-button-icon-size);
}

/* color='primary' */
:host([color=primary]) {
  background-color: rgba(var(--ui-3), var(--opacity-1));
}

:host([color=primary]:hover:not(:active):not(.no-hovermq)) {
  background-color: rgba(var(--ui-2), var(--opacity-1));
}

:host([color=primary]:active) {
  background-color: rgba(var(--ui-4), var(--opacity-1));
}

:host([color=primary]) .label,
:host([color=primary]) sh-icon {
  color: var(--text-white);
}

/* color='secondary' */
:host([color=secondary]) {
  background-color: rgba(var(--ui-1), var(--opacity-6));
}

:host([color=secondary]:hover:not(:active):not(.no-hovermq)) {
  background-color: rgba(var(--ui-1), var(--opacity-5));
}

:host([color=secondary]:active) {
  background-color: rgba(var(--ui-1), var(--opacity-7));
}

:host([color=secondary]) .label {
  color: var(--text-primary);
}

/* color='tertiary' */
:host(:not([icon])[color=tertiary]) {
  padding: var(--sh-button-button-padding);
  border: var(--sh-button-tertiary-border-thickness) solid rgba(var(--ui-1), var(--opacity-6));
  color: var(--text-primary);
}

:host(:not([icon])[color=tertiary]:hover:not(:active):not(.no-hovermq)) {
  background-color: rgba(var(--ui-1), var(--opacity-5));
}

:host(:not([icon])[color=tertiary]:active) {
  background-color: rgba(var(--ui-1), var(--opacity-7));
}

:host([color=tertiary]) {
  background-color: transparent;
}

:host([color=tertiary]) sh-icon {
  color: rgba(var(--ui-1), var(--opacity-3));
}

:host([icon][color=tertiary]:hover:not(:active):not(.no-hovermq)) sh-icon {
  color: rgba(var(--ui-1), var(--opacity-2));
}

:host([color=tertiary]:active) {
  background-color: rgba(var(--ui-1), var(--opacity-7));
}

:host([color=tertiary]) .label {
  color: var(--text-primary);
}

/* disabled */
:host([disabled]) {
  pointer-events: none;
  cursor: not-allowed;
}

:host([color=primary][disabled]) .label,
:host([color=primary][disabled]) sh-icon {
  color: var(--text-white-disabled);
}

:host(:not([color=primary])[disabled]) .label,
:host(:not([color=primary])[disabled]) sh-icon {
  color: rgba(var(--ui-1), var(--opacity-5));
}

:host([color=primary][disabled]) {
  background-color: rgba(var(--ui-2), var(--opacity-5));
}

:host([color=secondary][disabled]) {
  background-color: rgba(var(--ui-1), var(--opacity-7));
}

:host(:not([icon])[color=tertiary][disabled]) {
  border: var(--sh-button-tertiary-border-thickness) solid rgba(var(--ui-1), var(--opacity-7));
}

:host([color=tertiary]) .label {
  color: var(--text-primary);
}

/* tooltip */
.tooltip {
  text-overflow: inherit;
  z-index: 2;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  max-width: var(--sh-button-tooltip-max-width);
  line-height: var(--sh-button-tooltip-height);
  padding: 0 var(--sh-button-icon-padding);
  position: absolute;
  opacity: 0;
  visibility: hidden;
  color: var(--text-primary);
  background-color: var(--base-3);
  width: fit-content;
  width: -ms-fit-content;
  width: -moz-fit-content;
  height: var(--sh-button-tooltip-height);
  transition: var(--transition-time) all ease-in-out calc(var(--transition-time) * 2) s;
  -webkit-font-smoothing: antialiased !important;
  text-rendering: optimizeLegibility !important;
  -moz-osx-font-smoothing: grayscale !important;
}

.top,
.bottom {
  left: 50%;
  transform: translateX(-50%);
}

.left,
.right {
  top: 50%;
  transform: translateY(-50%);
}

.top.tooltip {
  top: var(--sh-button-tooltip-top-margin);
  margin-top: var(--sh-button-tooltip-margin-top);
}

.bottom.tooltip {
  top: 100%;
  margin-top: var(--sh-button-tooltip-top-margin);
}

.left.tooltip {
  right: 100%;
}

.right.tooltip {
  left: 100%;
}

/* touch */
:host(:hover:not(:active):not(.no-hovermq)) .tooltip {
  opacity: 1;
  visibility: visible;
}

:host(:hover:not(:active):not(.no-hovermq)) .top.tooltip {
  margin-top: var(--sh-button-tooltip-hover-margin-top);
}

:host(:hover:not(:active):not(.no-hovermq)) .bottom.tooltip {
  margin-top: var(--sh-button-tooltip-margin);
}

:host(:hover:not(:active):not(.no-hovermq)) .left.tooltip {
  margin-right: var(--sh-button-tooltip-margin);
}

:host(:hover:not(:active):not(.no-hovermq)) .right.tooltip {
  margin-left: var(--sh-button-tooltip-margin);
}

:host(:not([icon])) {
  /**
           * To prevent the browser from
           * shrinking the button when 
           * the window is resized to a
           * smaller size, we set 
           * flex-shrink to 0.
          */
  flex-shrink: 0;
  min-width: var(--sh-button-width-size-s);
  max-width: var(--sh-button-width-size-l);
}

:host([size=s]),
:host([shape=pill-s]) {
  width: var(--sh-button-width-size-s);
}

:host([size=m]),
:host([shape=pill-m]) {
  width: var(--sh-button-width-size-m);
}

:host([size=l]),
:host([shape=pill-l]) {
  width: var(--sh-button-width-size-l);
}

:host([size=auto]),
:host([size=max-content]) {
  width: -webkit-fit-content;
  width: -moz-fit-content;
  width: fit-content;
}

:host([size=max-content]) {
  max-width: unset;
}

:host([size=full-width]) {
  max-width: unset;
  width: 100%;
}`;